module.exports = "<app-confirm-window (openPopupEvent)=\"openPopup()\"></app-confirm-window>\r\n\r\n<button (click)=\"openPopup()\">Open Confirm Window</button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/poc-dev-sujeet/poc-dev-sujeet.component.html
// module id = ./src/app/pages/poc-dev-sujeet/poc-dev-sujeet.component.html
// module chunks = main